import SubjectAdapter from 'cio/adapters/subject';
import { resolve } from 'rsvp';

// Prevent the UI from calling the API to get the people count and return
// empty arrays instead.
export default class DemoSubjectAdapter extends SubjectAdapter {
  query() {
    return resolve({
      customers: [],
      subjects: [],
    });
  }
}
